<template>
  <div class="nav-category">
    <SortBar :type="1" />

    <template v-if="ready">
      <div v-if="products.length > 0" class="section-title">我的最愛</div>
      <div v-if="products.length > 0" class="section-content">
        <div v-for="(product, key) in products" :key="key" class="item">
          <product-block v-bind="{ info: product, modifier: 's' }" />
        </div>
        <SpinnerBottom class="mt-5" v-show="loading && products.length > 0" />
      </div>
      <div v-else class="section-content no-product-section">
        <div class="logo">
          <img src="@/assets/img/noproduct.svg" class="noproduct" />
        </div>
        <div class="title">沒找到合適的商品</div>
      </div>
    </template>
    <Spinner v-else bgc="#f6f6f6" />
    <v-overlay :value="showOverlay" :z-index="11"></v-overlay>
    <nav class="nav-sort">
      <v-expand-transition>
        <div v-show="isSortShow" class="filter-container">
          <div class="row-sort">
            <div
              v-for="(sort, key) in sorts"
              :key="key"
              v-ripple
              class="col col-12"
              :class="{ selected: sort.value === selectSort }"
              @click="selectedSort(sort.value)"
            >
              {{ sort.text }}
            </div>
          </div>
        </div>
      </v-expand-transition>
    </nav>
  </div>
</template>

<script>
import ProductBlock from '@/components/ProductBlock'
import Spinner from '@/components/shared/Spinner.vue'
import SpinnerBottom from '@/components/shared/SpinnerBottom'
import SortBar from '@/components/shared/SortBar.vue'

const sorts = [
  { text: '推薦', value: 0, displayText: '推薦' },
  { text: '最新', value: 1, displayText: '最新' },
  { text: '銷量', value: 2, displayText: '銷量' },
  { text: '折數', value: 3, displayText: '折數' },
  { text: '價格從低到高', value: 5, displayText: '價格' },
  { text: '價格從高到低', value: 4, displayText: '價格' },
]
export default {
  name: 'CollectionList',
  components: {
    ProductBlock,
    Spinner,
    SpinnerBottom,
    SortBar,
  },
  data: function() {
    return {
      sorts,
      selectSort: 0,
      isAreaShow: false,
      isSortShow: false,
      products: [],
      inTheEnd: false,
      loading: true,
      ready: false,
      triangleImage: require('@/assets/img/triangle-down.svg'),
      piPointImage: require('@/assets/img/icon/pi-point.svg'),
      piPoints: 0,
      showOverlay: false,
    }
  },
  watch: {},
  methods: {
    selectedSort(value) {
      if (value === this.selectSort) return
      this.selectSort = value
      this.isSortShow = false
      this.showOverlay = false
    },
    handleScroll() {
      if (this.loading) {
        return
      }
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop
      const scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight
      const windowHeight = window.screen.height
      const scrollBottom = scrollTop + windowHeight
      if (scrollBottom >= scrollHeight - 100 && this.inTheEnd == false) {
        // this.getProducts('', false)
      }
    },
    toggleSort() {
      this.isAreaShow = false
      this.isSortShow = !this.isSortShow
      this.showOverlay = this.isSortShow
    },
    toggleArea() {
      this.isSortShow = false
      this.isAreaShow = !this.isAreaShow
      this.showOverlay = this.isAreaShow
    },
    toTicket() {
      this.$router.push({ name: 'orderListTicket' })
    },
    async getCollectionList() {
      localStorage.setItem('collectionList', JSON.stringify([]))
      try {
        const res = await api.getCollectionList()
        this.products.push(...res.data)
        localStorage.setItem('collectionList', JSON.stringify(res.data))
        this.ready = true
        this.loading = false
      } catch (error) {
        if (error && error.code === 1140) {
          console.log('無收藏')
          this.ready = true
          this.loading = false
        }
      }
    },
  },
  created() {
    // window.addEventListener('scroll', this.handleScroll)
  },
  mounted() {
    const piInfo = localStorage.getItem('PI_POINTS')
    if (piInfo != null) this.piPoints = piInfo
    this.getCollectionList()
  },
  destroyed() {
    // window.removeEventListener('scroll', this.handleScroll)
  },
}
</script>

<style lang="scss" scoped>
.prevent-scroll {
  height: calc(100vh - 79px);
  overflow-y: hidden;
}

.nav-category {
  background-color: #f1f2f2;
  padding-top: 48px;
}

.events {
  position: fixed;
  right: 0;
  bottom: 90px;
}

.nav-container {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  font-size: 15px;
  white-space: nowrap;
  margin: 0 20px;

  .btn {
    flex: 1 1 33%;
    padding: 12px 0;
    outline: none;
    font-size: 15px;
    color: #222222;
    display: flex;
    align-items: center;
    margin: 0;
    &:nth-child(1) {
      justify-content: flex-start;
    }
    &:nth-child(2) {
      justify-content: center;
    }
    &:nth-child(3) {
      justify-content: flex-end;
    }
    img {
      margin-right: 8px;
    }
  }
}
.filter-container > {
  transition: all 0.2s ease;
  .row {
    padding: 0 10px;
    max-height: 384px;
    overflow-y: scroll;
    z-index: 999;
  }
  .row-sort {
    padding: 0 10px;
    max-height: 282px;
    overflow-y: scroll;
    z-index: 999;
  }
}
.filter-container .col {
  padding-left: 16px;
  padding-right: 23px;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #545454;

  &.selected {
    color: #1da7fc;
  }
}
.filter-container .col img {
  float: right;
}

.nav-sort {
  padding: 0 12px;
  background-color: #ffffff;
  position: fixed;
  bottom: 49px;
  left: 0;
  right: 0;
  z-index: 110;
  border-top-right-radius: 1rem;
  border-top-left-radius: 1rem;
}
.section-title {
  font-size: 18px;
  font-weight: bold;
  color: #383838;
  background-color: #fff;
  padding: 20px 4.8% 0;
}
.section-content {
  display: flex;
  padding: 10px 4.8% 0px;
  flex-flow: row wrap;
  background-color: white;
  > .item {
    flex: 1 1 calc(50% - 9px);
    margin: 0 4.5px 10px 4.5px;
    flex-grow: 0;
  }
}

.no-product-section {
  display: block;
  justify-content: center;
  padding-top: 40%;
  padding-bottom: 60%;
  .logo {
    text-align: center;
    display: block;
  }
  .title {
    font-family: PingFangTC;
    font-weight: bold;
    font-size: 18px;
    color: #9b9b9b;
    display: block;
    text-align: center;
    font-size: 1.5em !important;
    line-height: 2em;
  }
  .subtitle {
    font-family: PingFangTC;
    font-weight: normal;
    font-size: 14px;
    color: #9b9b9b;
    display: block;
    text-align: center;
    font-size: 1em !important;
    line-height: 1.2em;
  }
  .noproduct {
    width: 72px;
    height: 72px;
    object-fit: contain;
  }
}

.bg-gray {
  display: block;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 10;
}

.filter-bar {
  margin-bottom: 1px;
  padding: 10px 18px;
  height: 48px;
  background: white;
  box-shadow: 0 1px 0 0 #dddddd;
  z-index: 12;
  position: fixed;
  width: 100%;
  top: 0;

  &--row {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &-pi-point {
    height: 30px;
    padding: 5px 10px;
    border-radius: 24px;
    border: solid 1px #bbbbbb;
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #1da7fc;
    display: flex;
    align-items: center;

    &__icon {
      width: 16px;
      height: 18px;
    }

    &__amount {
    }
  }

  &-button {
    display: flex;
    width: 95px;
    justify-content: space-between;
    align-items: center;

    &__sort {
      height: 20px;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: 0.44px;
      text-align: right;
      color: #383838;
      vertical-align: middle;
      display: flex;

      img {
        margin-left: 5px;
        transition: 300ms;

        &.show-menu {
          transform: rotate(180deg);
          transition: 300ms;
        }
      }
    }

    .icon {
      width: 28px;
      height: 28px;
      margin-left: 20px;
      img {
        width: 100%;
        margin-left: 0;
      }
    }
  }
}
</style>
